// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainDialog {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  min-width: 320px;
}

.header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mainTestContent {
  padding: 1.5rem;
}

.mainTableContainer {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #DCDFE1;
  border-radius: 0.2rem;
  margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/UserManagement/TestAssignment/assignment.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAGA;EACI,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAAJ","sourcesContent":[".mainDialog {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    min-width: 320px;\n}\n\n.header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.mainTestContent {\n    padding: 1.5rem;\n}\n\n\n.mainTableContainer {\n    width: 100%;\n    overflow-x: auto;\n    border: 1px solid #DCDFE1;\n    border-radius: 0.2rem;\n    margin-top: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
